export default {
    productLibrary: '产品和技术解决方案',
    newsAndFocus: '新闻和焦点',
    checkMoreNews: '查看更多新闻',
    regulatoryComplianceServe: '监管合规服务',
    riskManagementServe: '风险管理服务',
    strategyAndOperationServe: '战略与运营服务',
    regulatoryComplianceContent: '围绕金融机构合规管理体系，锐合为客户提供丰富的监管合规咨询服务及因地制宜的解决方案，广泛覆盖金融机构合规义务的各个方面，包括打击金融犯罪、隐私与数据保护、监管合规和行为、定制合规培训等，协助金融机构应对日益严峻的监管环境。',
    regulatoryComplianceContent1: '锐合团队深耕于中国资本计量与规划、资产负债管理与巴塞尔协议合规风险管理咨询服务。针对金融机构面临不断演化的新巴三风险管理、数据治理、信创与国产化要求，锐合为客户打造专属“国产化”时代的风控管理咨询方案以及高技术壁垒的核心计量引擎。',
    regulatoryComplianceContent2: '锐合协助金融机构准备跨境申牌时所需的支持文件，以满足当地监管对申牌的要求。同时，锐合提供合规外包服务，以减轻金融机构合规运营的压力，帮助金融机构提高合规工作质量。',
    inputName: '请输入您的名称',
    inputPhoneNumber: '请输入您的电话',
    inputEmail: '请输入您的邮箱',
    inputCorrectEmail: '请输入您正确的邮箱',
    inputRemark: '您可以咨询我们相关服务和产品的任何信息，如果您需要，我们将提供各种形式的展示与介绍',
    submit: '提交',
    beijingRoom: '北京办公室',
    beijingPlace: '北京市东城区银河SOHO B座11层21106',
    hongKongRoom: '香港办公室',
    hongKongPlace: '香港九龙观塘巧明街116-118号万年工业大厦8层A17',
    monmentPosition: '当前位置',
    productContent1: '锐合的监管科技应用产品服务于合规管理的各个方面，从机构风险评估、数据合规评估，到政策合规评估，覆盖监管检查所涉到的各大风险领域，落实以风险为本的管理理念。',
    productContent2: '锐合的风险管理计量产品服务于金融机构应对银保监会、证监会资本与流动性监管、并表管理与风险管控的各个方面，覆盖三大支柱、九大风险，全面提升金融机构计量与管理能力。',
    productContent3: '锐合致力于对新技术和新趋势的持续研究，在人工智能、区块链、云技术、大数据等新技术的支持下，推出新的业务模式、应用、流程或产品，为金融机构数字化转型提供有力支持。',
    productContent4: '锐合持续追踪监管趋势和动向，结合咨询服务和产品，开展知识体系研究，建立专属图书馆和工具箱，优化咨询服务质量、推动技术解决方案升级。',
    productRightTitle: '产品与技术',
    productRightContent: '',
    newsList: '新闻主页',
    news: '新闻',
    noData: '暂无数据',
    newsDetail: '新闻内页',
    productContent: '我们的产品和技术解决方案覆盖风险评估、风险计量和流程优化与自动化等方面。我们充分运用机器学习、人工智能等方法，在风险建模、合规管理、数据分析等领域帮助金融机构更好地管理风险，提高效率。',

    riskmanagement: '风险管理类',
    complianceManagement: '合规管理类',
    newSomething: '新技术和新趋势类',
    libraryAndSetting: '图书馆和工具箱类',

}